import { CheckboxGroup, type CheckboxGroupProps } from '@chakra-ui/react';

export type UiCheckboxGroupProps = CheckboxGroupProps;

export const UiCheckboxGroup = CheckboxGroup;
